import { baseApi } from "../baseApi";

export const auricsuiteglobalapi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    postSearchFilterApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: "POST",
        body,
      }),
    }),
    postDefaultTaxandChargeApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/erpnext.accounts.party.get_party_details`,
        method: "POST",
        body,
      }),
    }),
    postValidateLinkApi: builder.mutation({
      query: (body) => ({
        url: `/api/method/frappe.client.validate_link`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {usePostSearchFilterApiMutation,usePostDefaultTaxandChargeApiMutation,usePostValidateLinkApiMutation} = auricsuiteglobalapi;
